import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import {
  RenderTextField as TextField
} from '../formInputs';

import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  success: {
    // backgroundColor: green500,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: '#ffffff',
    backgroundColor: theme.palette.error.dark,
  },
  snackbar: {
    margin: theme.spacing.unit,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  title: {
    marginTop: 10,
  },
  radioBtn: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  }
});

class EndrosmentForm extends Component {
  static propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    removeMessage: PropTypes.func,
    error: PropTypes.string,
    addEndrosment: PropTypes.func
  };

  render() {
    const {
      classes,
      handleSubmit,
      addEndrosment,
      message,
      error,
    } = this.props;

    return (
      <React.Fragment>

        {
          (error !== undefined) &&
          <SnackbarContent
            className={classes.error}
            message={
              <span className={classes.message}>
                <ErrorIcon className={`${classes.icon} ${classes.iconVariant}`} />
                {error.toString()}
              </span>
            }
          />
        }

        <Form className={classes.form} onSubmit={handleSubmit(addEndrosment)}>

          <FormControl margin="normal" className={classes.textField} required>
            <Field name="name" component={TextField} label="Endrosment Name" />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Add
          </Button>

        </Form>

      </React.Fragment>
    );
  }
}

export default withStyles(styles)(EndrosmentForm);